<template>
    <div class="willding-price-widget" v-if="bidValue">
        <div class="willding-price-widget-bid-value">
            <span>Gebot:</span> <span class="money">{{ bidValue|round }}</span>
        </div>
        <div class="willding-price-widget-bid-fee">
            <span>Gebühr {{ auctionFeePercentage }}%:</span> <span class="money">{{ bidFee|round }}</span>
        </div>
        <div class="willding-price-widget-tax">
            <span>MwSt. {{ mwstPercentage }}%:</span> <span class="money">{{ tax|round }}</span>
        </div>
        <div class="willding-price-widget-sum">
            <span>Summe:</span> <span class="money">{{ bidAll|round }}</span>
        </div>
    </div>
</template>

<style lang="css">

.willding-price-widget {
    border: 1px solid #27A099;
    text-align: left;
    padding: 5px;
    margin: 10px  50px;
}

.willding-price-widget-sum {
    border-top: 2px solid black;
    border-bottom: 1px double black;
    padding: 4px 0px;
}

.willding-price-widget > div {
    display: grid;
    grid-template-columns: 120px auto;
    padding: 4px 0px;
}

</style>

<script>

export default {
    name: 'WillDingPrice',
    data(){
        return {
            bidField: null,
            bidFieldListener: false,
            taxType: null,
        }
    },
    filters: {
        round(val){
            const roundedVal = Math.round(parseFloat(val)*100)/100
            return roundedVal.toLocaleString("de-AT", { style: 'currency', currency: 'EUR'})
        }
    },
    mounted(){
        this.refreshBidField()
        setTimeout(() => { this.refreshBidField() }, 250)
        setTimeout(() => { this.refreshBidField() }, 500)
        setTimeout(() => { this.refreshBidField() }, 1000)
    },
    methods: {
        createListeners(){
            if (this.bidField && !this.bidFieldListener){
                this.bidField.addEventListener("change", () => { this.refreshBidField() })
                this.bidFieldListener = true
            }
        },
        refreshBidField(){
            this.bidField = null
            this.bidField = document.querySelector("form.auction_form div.quantity input[name=bid_value]")
            this.createListeners()
            this.refreshTaxType()
        },
        refreshTaxType(){
            const ttField = document.querySelector("p.wc-gzd-additional-info.tax-info")
            //console.log("refreshTaxType ttField", ttField)
            if (ttField){
                //console.log("refreshTaxType search", ttField.innerHTML.search("differenz"))
                if (ttField.innerHTML.search("differenz") != -1){
                    this.taxType = "differenz"
                } else { 
                    this.taxType = "mwst"
                }
            } else {
                //console.log("refreshTaxType field not found")
                this.taxType = "mwst"
            }
        },
    },
    computed: {
        auctionFeePercentage(){
            if (this.taxType == "differenz"){
                return 22
            } else {
                return 18
            }
        },
        mwstPercentage(){
            if (this.taxType == "differenz"){
                return 0
            } else {
                return 20
            }
        },
        bidValue(){
            if (this.bidField && this.bidField.value){
                return parseFloat(this.bidField.value.replaceAll("€", "").replaceAll(".", "").split(",")[0])
            } else {
                return 0
            }
        },
        bidFee(){
            if (this.bidValue){
                return this.bidValue * (this.auctionFeePercentage/100)
            } else {
                return 0
            }
        },
        tax(){
            if (this.bidValue && this.bidFee){
                return (this.bidValue+this.bidFee) * (this.mwstPercentage/100)
            } else {
                return 0
            }
        },
        bidAll(){
            if (this.bidValue && this.bidFee){
                return this.bidValue + this.bidFee + this.tax
            } else {
                return null
            }
        }
    },
    watch: {
    }
}

</script>